export enum ElementGroup {
  /// <summary>
  /// مزایا
  /// </summary>
  Bonus = 1,
  /// <summary>
  /// کسور
  /// </summary>
  Deduct = 2,
  /// <summary>
  /// تعهدات
  /// </summary>
  Boss = 3,
  /// <summary>
  /// کارکرد
  /// </summary>
  Work = 4,
  /// <summary>
  /// وام
  /// </summary>
  Loan = 5,
  /// <summary>
  /// سایر
  /// </summary>
  Other = 6,
  /// <summary>
  /// ذخیره عیدی و پاداش
  /// </summary>
  RwrdSave = 7,
  /// <summary>
  /// هزینه عیدی و پاداش
  /// </summary>
  RwrdPay = 8,
  /// <summary>
  /// ذخیره مرخصی
  /// </summary>
  VacationSave = 9,
  /// <summary>
  /// بازخرید مرخصی
  /// </summary>
  VacationBuy = 10,
  /// <summary>
  /// ذخيره سنوات خدمت
  /// </summary>
  EstablishmentTheReserveOfYearsOfService = 11,
}
